import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    aboutStatutes:
      'In order to open your Shine account, we need to ask you for your company statutes.\nYou can upload it in a minute directly in the app.',
    addDocumentAction: 'Add your company statutes',
    backButtonClose: 'Close',
    ctaContinue: 'Continue',
    faqQuestions: 'What document should I upload?',
    refusedLabel: 'Refused',
    statutesDocumentName: 'Statutes Document',
    title: 'Your company statutes',
  },
  fr: {
    aboutStatutes:
      'Pour ouvrir le compte professionnel de votre entreprise, nous avons besoin des statuts de votre société.\nVous pouvez les ajouter directement dans l’appli en une minute',
    addDocumentAction: 'Ajoutez les statuts de votre entreprise',
    backButtonClose: 'Fermer',
    ctaContinue: 'Continuer',
    faqQuestions: 'Quel document dois-je fournir\u00A0?',
    refusedLabel: 'Refusé',
    statutesDocumentName: 'Statuts',
    title: 'Statuts de la société',
  },
} as const);
